import React from "react";
import { NakiNigunHomePageHeaderTemplate } from "themes/application/naki-nigun/components";

function NakiNigunHomePageHeader(props) {
    return <NakiNigunHomePageHeaderTemplate {...props} />;
}

export default NakiNigunHomePageHeader;
